import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "fixed inset-0 z-50 flex items-center justify-center"
}
const _hoisted_2 = { class: "flex items-center justify-center min-h-screen text-center" }
const _hoisted_3 = { class: "bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-4 w-[98vw] h-[95vh]" }
const _hoisted_4 = { class: "bg-white px-6 pt-6 pb-4 sm:p-8 sm:pb-6 h-[calc(95vh-70px)] overflow-y-auto overflow-x-hidden" }
const _hoisted_5 = { class: "flex justify-between items-start" }
const _hoisted_6 = { class: "text-xl font-bold text-gray-900 flex items-center justify-between w-full" }
const _hoisted_7 = { class: "flex gap-5" }
const _hoisted_8 = { class: "flex gap-2" }
const _hoisted_9 = { class: "flex-shrink-0" }
const _hoisted_10 = ["src"]
const _hoisted_11 = {
  key: 1,
  class: "h-8 w-8 rounded-full bg-gray-200 mr-2 flex items-center justify-center"
}
const _hoisted_12 = { class: "text-gray-500 text-sm" }
const _hoisted_13 = { class: "flex items-center mt-1" }
const _hoisted_14 = { class: "text-sm" }
const _hoisted_15 = { class: "mt-4 grid grid-cols-4" }
const _hoisted_16 = {
  key: 0,
  class: "col-span-1 px-4"
}
const _hoisted_17 = {
  key: 0,
  class: "mt-6 flex items-center justify-center py-8"
}
const _hoisted_18 = {
  key: 1,
  class: "mt-4 p-3 bg-green-100 border border-green-300 rounded-md text-green-700 flex items-center"
}
const _hoisted_19 = {
  key: 2,
  class: "mt-4 p-3 bg-red-100 border border-red-300 rounded-md text-red-700 flex items-center"
}
const _hoisted_20 = { class: "bg-gray-50 px-4 py-3 sm:px-6 flex justify-end" }
const _hoisted_21 = ["disabled"]
const _hoisted_22 = ["disabled"]
const _hoisted_23 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DocumentComparisonSpreadsheet = _resolveComponent("DocumentComparisonSpreadsheet")!
  const _component_CommentList = _resolveComponent("CommentList")!

  return (_ctx.isOpen)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", {
            class: "fixed inset-0 transition-opacity",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
          }, _cache[6] || (_cache[6] = [
            _createElementVNode("div", { class: "absolute inset-0 bg-gray-500 opacity-75" }, null, -1)
          ])),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("h3", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", null, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.documentData.name), 1)
                    ]),
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("div", _hoisted_9, [
                        (_ctx.documentData.created_by_avatar_url)
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              src: _ctx.documentData.created_by_avatar_url,
                              alt: "Avatar",
                              class: "h-8 w-8 rounded-full mr-2"
                            }, null, 8, _hoisted_10))
                          : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                              _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.documentData.created_by_name?.charAt(0) || '?'), 1)
                            ]))
                      ]),
                      _createElementVNode("span", null, _toDisplayString(_ctx.documentData.created_by_name), 1)
                    ]),
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["w-3 h-3 rounded-full mr-2", {
                    'bg-green-700': _ctx.documentData.status === _ctx.DOCUMENT_STATUS.UPLOADED_CHECKING
                  }])
                      }, null, 2),
                      _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.formatDocumentStatus(_ctx.documentData.status)), 1)
                    ])
                  ]),
                  _createElementVNode("button", {
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.commentsVisible = !_ctx.commentsVisible)),
                    class: "ml-4 px-3 py-1 bg-gray-200 text-gray-700 rounded-md text-sm"
                  }, "Toggle Comments")
                ]),
                _createElementVNode("button", {
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args))),
                  class: "text-gray-400 hover:text-gray-500"
                }, _cache[7] || (_cache[7] = [
                  _createElementVNode("svg", {
                    class: "h-6 w-6",
                    fill: "none",
                    viewBox: "0 0 24 24",
                    stroke: "currentColor"
                  }, [
                    _createElementVNode("path", {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "stroke-width": "2",
                      d: "M6 18L18 6M6 6l12 12"
                    })
                  ], -1)
                ]))
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", {
                  class: _normalizeClass({ 'col-span-3': _ctx.commentsVisible, 'col-span-4': !_ctx.commentsVisible })
                }, [
                  _createVNode(_component_DocumentComparisonSpreadsheet, {
                    "document-data": _ctx.documentData,
                    onClose: _ctx.close
                  }, null, 8, ["document-data", "onClose"])
                ], 2),
                (_ctx.commentsVisible)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                      _createVNode(_component_CommentList, {
                        referenceId: _ctx.documentData.id
                      }, null, 8, ["referenceId"])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _cache[11] || (_cache[11] = _createElementVNode("div", { class: "mt-6 bg-blue-50 border border-blue-200 rounded-lg p-4" }, [
                _createElementVNode("h4", { class: "text-sm font-medium text-blue-700" }, "Review Instructions"),
                _createElementVNode("p", { class: "mt-1 text-sm text-blue-600" }, " Please review the uploaded template and findings above, then decide whether to approve or decline it. If approved, the document will be moved to \"Ready for Revision\". If declined, the document will be moved to \"Adjustment Needed\" and the owner will be notified. ")
              ], -1)),
              (_ctx.isLoading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_17, _cache[8] || (_cache[8] = [
                    _createElementVNode("div", { class: "text-gray-500 flex flex-col items-center" }, [
                      _createElementVNode("svg", {
                        class: "animate-spin h-10 w-10 text-primary mb-4",
                        xmlns: "http://www.w3.org/2000/svg",
                        fill: "none",
                        viewBox: "0 0 24 24"
                      }, [
                        _createElementVNode("circle", {
                          class: "opacity-25",
                          cx: "12",
                          cy: "12",
                          r: "10",
                          stroke: "currentColor",
                          "stroke-width": "4"
                        }),
                        _createElementVNode("path", {
                          class: "opacity-75",
                          fill: "currentColor",
                          d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                        })
                      ]),
                      _createElementVNode("p", null, "Processing...")
                    ], -1)
                  ])))
                : _createCommentVNode("", true),
              (_ctx.successMessage)
                ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                    _cache[9] || (_cache[9] = _createElementVNode("svg", {
                      class: "h-5 w-5 mr-2",
                      fill: "none",
                      stroke: "currentColor",
                      viewBox: "0 0 24 24",
                      xmlns: "http://www.w3.org/2000/svg"
                    }, [
                      _createElementVNode("path", {
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        "stroke-width": "2",
                        d: "M5 13l4 4L19 7"
                      })
                    ], -1)),
                    _createElementVNode("span", null, _toDisplayString(_ctx.successMessage), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.errorMessage)
                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                    _cache[10] || (_cache[10] = _createElementVNode("svg", {
                      class: "h-5 w-5 mr-2",
                      fill: "none",
                      stroke: "currentColor",
                      viewBox: "0 0 24 24",
                      xmlns: "http://www.w3.org/2000/svg"
                    }, [
                      _createElementVNode("path", {
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        "stroke-width": "2",
                        d: "M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                      })
                    ], -1)),
                    _createElementVNode("span", null, _toDisplayString(_ctx.errorMessage), 1)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("button", {
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args))),
                class: "mr-2 inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:text-sm",
                disabled: _ctx.isLoading
              }, " Cancel ", 8, _hoisted_21),
              _createElementVNode("button", {
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.declineTemplate && _ctx.declineTemplate(...args))),
                class: "mr-2 inline-flex justify-center rounded-md border border-red-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-red-700 hover:bg-red-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:text-sm",
                disabled: _ctx.isLoading
              }, " Decline ", 8, _hoisted_22),
              _createElementVNode("button", {
                onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.approveTemplate && _ctx.approveTemplate(...args))),
                class: "inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-blue-600 text-base font-medium text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:text-sm",
                disabled: _ctx.isLoading
              }, " Approve ", 8, _hoisted_23)
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}